import * as types from './mutation-types';

export default {
  [types.SET_CATEGORY_COLLECTION](state, payload) {
    state.categoryCollection = payload;
  },
};
